export default __webpack_public_path__ + "static/media/le_lion10.d8bb647a.jpg";